module.exports = __webpack_public_path__ + "img/Fenêtre pvc + habillage intérieur.2410121f.jpg";